<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="12">
          <el-page-header @back="onBack" title="" content="學習排行榜">
          </el-page-header>
        </el-col>
      </el-row>
    </div>

    <div class="page-content">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="冒險模式" name="first"></el-tab-pane>
        <el-tab-pane label="圖書館模式" name="second"></el-tab-pane>
      </el-tabs>
      <div class="page-box">
        <div class="page-content-row">
          <div >
            <el-input size="small"
                v-model="listQuery.userNoLike"
                placeholder="學生帳號"
            ></el-input>
          </div>
          <div >
            <el-select size="small"
                v-model="listQuery.branchSchoolId"
                clearable
                placeholder="分校"
            >
              <el-option size="small"
                  v-for="(item, index) in sortBranchesList"
                  :key="index"
                  :label="item.abbreviation"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div >
            <el-select size="small" v-model="listQuery.gradeId" clearable placeholder="年級">
              <el-option size="small"
                  v-for="(item, index) in grades"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </div>

          <div>
            <el-select size="small" v-model="listQuery.lang" placeholder="語言版本">
              <el-option size="small"
                  key="0"
                  label="繁體"
                  value="0">
              </el-option>
              <el-option
                  key="1"
                  label="English"
                  value="1">
              </el-option>
            </el-select>
          </div>
            <el-date-picker size="small" clearable
                            v-model="listQuery.dateValue"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="做題開始日期"
                            end-placeholder="做題截止日期"
                            :picker-options="pickerOptions">
            </el-date-picker>
              <el-button size="mini" type="info" class="button-el-el" @click.native="onSearch">搜尋</el-button>
        </div>
      </div>

      <el-table
          v-loading="loading"
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
      >
        <el-table-column label="排名" prop="ranking" width="50"> </el-table-column>
        <el-table-column prop="branchSchoolId" label="分校" align="center" sortable="custom">
          <template slot-scope="{ row }">
            <span v-if="row.branchSchool">{{ row.branchSchool.abbreviation }}</span>
          </template>
        </el-table-column>
<!--        <el-table-column prop="gradeId" label="年級" align="center" sortable="custom">-->
<!--          <template slot-scope="{ row }">-->
<!--            <span v-if="row.grade">{{ row.grade.name }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
            prop="userNo"
            label="學生帳號"
            align="center"
            sortable="custom"
        >
        </el-table-column>
        <el-table-column
            prop="name"
            label="學生姓名"
            align="center"
            sortable="custom"
        >
        </el-table-column>
        <el-table-column
            prop="studying"
            label="課程語言"
            align="center"
            sortable="custom"
        >
          <template slot-scope="{row}">
            <span>{{row.studying==0?'繁':'En'}}</span>
          </template>
        </el-table-column>
        <el-table-column
            v-if="activeName=='first'"
            prop="stars"
            label="星星總數（大蛋）"
            align="center"
            sortable="custom"
        >
          <template slot-scope="{row}">
            <span>{{row.stars}}</span>
          </template>
        </el-table-column>
        <el-table-column
            v-if="activeName=='second'"
            prop="stars"
            label="細蛋總數"
            align="center"
            sortable="custom"
        >
          <template slot-scope="{row}">
            <span>{{row.stars}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="overallPerformance"
            label="答對率"
            align="center"
            sortable="custom"
        >
        </el-table-column>
        <el-table-column
            prop="subCorrectQuantity"
            label="答對數/總答題數"
            align="center"
            sortable="custom"
        >
          <template slot-scope="{row}">
            <span>{{row.subCorrectQuantity}}/{{row.subScore}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="totalAnsweringMinutes"
            label="答題時長(分鐘)"
            align="center"
            sortable="custom"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {getLearningRankingList} from "@/api/users";
import {getGrades} from '@/api/grade'
export default {
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "封鎖" : "生效";
    },
    subscriptionStatus(v) {
      return v === 0 ? "無訂閱" : v === 1 ? "訂閱中" : v === 2 ? "過期" : "等待開始";
    },
  },
  data() {
    return {
      activeName: 'first',
      loading: true,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一個月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三個月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 12);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      selectedRows: [],
      total: 0,
      userId: null,
      listQuery: {
        userNoLike: null,
        nameLike: null,
        parentEmailLike: null,
        studentCodeLike: null,
        gender: null,
        lang: '0',
        gradeId: 1,
        objectType: 1,
        dateValue: '',
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
      avatars: [],
      grades: [],
      form: {
        ids: null
      },
    };
  },
  created() {
    this.getUsers();
    this.getGrades();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(this.activeName);
      this.onSearch();
    },
    getGrades(){
      getGrades().then((res)=>{
        this.grades = res.data
      })
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getUsers();
    },
    onSearch() {
      this.getUsers();
    },
    onReset() {
      Object.keys(this.listQuery).forEach((key) => {
        this.listQuery[key] = null;
        if (key === "_page") {
          this.listQuery[key] = 1;
        } else if (key === "_limit") {
          this.listQuery[key] = 50;
        }
      })
      this.getUsers();
    },
    getUsers() {
      this.loading=true;
      if(this.activeName=='first'){
        //冒險模式
        this.listQuery.objectType=1
      }else{
        //圖書館模式
        this.listQuery.objectType=0
      }
      let listQuery = {
        type: 2,
        userNoLike: this.listQuery.userNoLike,
        nameLike: this.listQuery.nameLike,
        objectType: this.listQuery.objectType,
        parentEmailLike: this.listQuery.parentEmailLike,
        studentCodeLike: this.listQuery.studentCodeLike,
        branchSchoolId: this.listQuery.branchSchoolId,
        lang: this.listQuery.lang,
        startDate: this.convertToDateTimeStr(this.listQuery.dateValue[0],0), // 开始日期（Date 对象）
        endDate: this.convertToDateTimeStr(this.listQuery.dateValue[1],1),   // 结束日期（Date 对象）
        gender: this.listQuery.gender,
        gradeId: this.listQuery.gradeId,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
      };
      getLearningRankingList(listQuery).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
        this.loading=false;
      });
    },
    convertToDateTimeStr(isoStr,type){
      if(isoStr == null){
        return null;
      }
      // 转换函数：ISO字符串 → yyyy-MM-dd HH:mm:ss（本地时区）
      const date = new Date(isoStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      // 提取本地时区的时、分、秒（补0）
      if(type==0){
        return `${year}-${month}-${day} 00:00:00`;
      }else {
        return `${year}-${month}-${day} 23:59:59`;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
  .demo-ruleForm-div {
    margin-top: 40px;
  }
  ::v-deep {
    .cell {
      color: black;
    }
  }
}
.form-avatar {
  position: relative;
  width: 90px;
  height: 90px;
}
.search-text {
  margin-bottom: 12px;
  color: #8e8e8e;
}
.page-content {
  background-color: #fff;
}
.page-box{
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}
.page-content-row {
  padding: 30px 10px;
  display: grid;
  justify-content: start;
  padding: 20px;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(1, 1fr);
  gap: 8px;
}
.page-content-row>div{
  min-width: 80px;
}
.page-content-row>div:nth-last-child(1){
  min-width: 80px;
  grid-column-start: 10;
}
.page-content-row>div:nth-last-child(2){
  min-width: 80px;
}
.page-content-row>div:nth-last-child(3){
  min-width: 80px;
}
.button-el-el {
  margin-top: 0px;
}
.studentCode{
  color: #027915;
}
.isStudentCode{
  color: #9C0000;
}
</style>